import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0857af9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "logo-container" }
const _hoisted_3 = { class: "login-form-container" }

import DvLogoComponent from '@/shared/auth/DvLogoComponent.vue';
import AuthForm from '@/shared/auth/AuthForm.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DvLogoComponent)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AuthForm)
    ])
  ]))
}
}

})